/**
 * @module "formkit"
 */

define('formkit/formkit',['require','exports','module','./model/answer.model','./model/answer.value.model','./model/condition.model','./model/rule.model','./model/template.model','./model/template.object.model','./model/template.compare.model','./model/template.object.type.model','./form.object.util','./form','./view/form.object/form.object.collection.view','./view/form.object/base.form.object.view','./view/form.object/common/base.form.object.top.view','./view/form.object/common/design.general.view','./view/form.object/common/preview.general.view','./behavior/go.to.next.section.behavior','./behavior/go.to.previous.section.behavior','./behavior/go.to.selected.section.on.event.behavior','./view/form.object/content/base.content.view','./view/form.object/content/base.input.content.view','./view/form.object/content/checkbox.content.view','./view/form.object/content/date.input.content.view','./view/form.object/content/dropdown.content.view','./view/form.object/content/information.content.view','./view/form.object/content/input.content.view','./view/form.object/content/numeric.input.content.view','./view/form.object/content/radio.content.view','./view/form.object/rule/rule.target.modal.view','./view/form.object/content/currency.input.content.view','./behavior/bind.option.to.active.section.change.behavior','./behavior/answer.save.behavior','./view/block/answer.form.object.collection.view','./view/block/answer.section.header.view','./view/block/answer.section.menu.view','./view/block/design.form.object.collection.view','./view/block/design.form.object.menu.view','./view/block/design.section.header.view','./view/block/design.section.menu.view','./view/block/compare.form.object.collections.view','./view/block/section.dropdown.view','./view/block/revisions.menu.view','./behavior/answer.form.root.behavior','./behavior/design.form.root.behavior'],function(require, exports, module) {
  //prettier-ignore
  var FormKit = {
    AnswerModel             : require('./model/answer.model'),
    AnswerValueModel        : require('./model/answer.value.model'),
    ConditionModel          : require('./model/condition.model'),
    RuleModel               : require('./model/rule.model'),
    TemplateModel           : require('./model/template.model'),
    TemplateObjectModel     : require('./model/template.object.model'),
    TemplateCompareModel    : require('./model/template.compare.model'),
    TemplateObjectTypeModel : require('./model/template.object.type.model'),

    FormObjectUtil          : require('./form.object.util'),
    Form                    : require('./form'),
    FormObjectCollectionView: require('./view/form.object/form.object.collection.view'),
    BaseFormObjectView      : require('./view/form.object/base.form.object.view'),
    BaseFormObjectTopView   : require('./view/form.object/common/base.form.object.top.view'),
    DesignGeneralView       : require('./view/form.object/common/design.general.view'),
    PreviewGeneralView      : require('./view/form.object/common/preview.general.view'),

    GoToNextSectionBehavior           : require('./behavior/go.to.next.section.behavior'),
    GoToPreviousSectionBehavior       : require('./behavior/go.to.previous.section.behavior'),
    GoToSelectedSectionOnEventBehavior: require('./behavior/go.to.selected.section.on.event.behavior'),

    BaseContentView         : require('./view/form.object/content/base.content.view'),
    BaseInputContentView    : require('./view/form.object/content/base.input.content.view'),
    CheckboxContentView     : require('./view/form.object/content/checkbox.content.view'),
    DateInputContentView    : require('./view/form.object/content/date.input.content.view'),
    DropdownContentView     : require('./view/form.object/content/dropdown.content.view'),
    InformationContentView  : require('./view/form.object/content/information.content.view'),
    InputContentView        : require('./view/form.object/content/input.content.view'),
    NumericInputContentView : require('./view/form.object/content/numeric.input.content.view'),
    RadioContentView        : require('./view/form.object/content/radio.content.view'),
    RuleTargetModalView     : require('./view/form.object/rule/rule.target.modal.view'),
    CurrencyInputContentView: require('./view/form.object/content/currency.input.content.view'),

    BindOptionToActiveSectionChangeBehavior: require('./behavior/bind.option.to.active.section.change.behavior'),

    AnswerSaveBehavior: require('./behavior/answer.save.behavior'),

    //Blocks
    Block: {
      // answer
      AnswerFormObjectCollectionView: require('./view/block/answer.form.object.collection.view'),
      AnswerSectionHeaderView       : require('./view/block/answer.section.header.view'),
      AnswerSectionMenuView         : require('./view/block/answer.section.menu.view'),

      // design
      DesignFormObjectCollectionView: require('./view/block/design.form.object.collection.view'),
      DesignFormObjectMenuView      : require('./view/block/design.form.object.menu.view'),
      DesignSectionHeaderView       : require('./view/block/design.section.header.view'),
      DesignSectionMenuView         : require('./view/block/design.section.menu.view'),

      // compare
      CompareFormObjectCollectionsView: require('./view/block/compare.form.object.collections.view'),
      SectionDropdownView             : require('./view/block/section.dropdown.view'),

      // revisions
      RevisionsMenuView: require('./view/block/revisions.menu.view'),

      // behaviors
      AnswerFormRootBehavior: require('./behavior/answer.form.root.behavior'),
      DesignFormRootBehavior: require('./behavior/design.form.root.behavior'),
    },
  };

  module.exports = FormKit;
});

